import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { PayoutAgreementService } from '../../services/payout-agreement.service'
import { catchError, map, mergeMap, of } from 'rxjs'
import {
  editPayout,
  editPayoutFailure,
  editPayoutSuccess,
  payoutAgreementActions,
  payoutRevisionActions
} from './payout-agreement.actions'
import { ToastrService } from 'ngx-toastr'

//Load All Payout Agreements Effect
export const loadAllPayoutAgreements$ = createEffect(
  (actions$ = inject(Actions), payoutAgreementService = inject(PayoutAgreementService)) =>
    actions$.pipe(
      ofType(payoutAgreementActions.loadAllPayoutAgreements),
      mergeMap(({ employeeId }) =>
        payoutAgreementService.loadAllPayoutAgreements(employeeId).pipe(
          map(payoutAgreement =>
            payoutAgreementActions.loadAllPayoutAgreementsSuccess({
              payoutAgreements: payoutAgreement
            })
          ),
          catchError(error => of(payoutAgreementActions.loadAllPayoutAgreementsFailure({ error })))
        )
      )
    ),
  { functional: true }
)

//Load Latest Payout Agreement Of A Single Employee
const loadPayoutAgreement$ = createEffect(
  (actions$ = inject(Actions), payoutAgreementService = inject(PayoutAgreementService)) =>
    actions$.pipe(
      ofType(payoutAgreementActions.loadPayoutAgreement),
      mergeMap(({ employeeId }) =>
        payoutAgreementService.getPayoutAgreement(employeeId).pipe(
          map(payoutAgreement =>
            payoutAgreementActions.loadPayoutAgreementSuccess({ payoutAgreement })
          ),
          catchError(error => of(payoutAgreementActions.loadPayoutAgreementFailure({ error })))
        )
      )
    ),
  { functional: true }
)

const addPayoutAgreement$ = createEffect(
  (
    actions$ = inject(Actions),
    payoutAgreementService = inject(PayoutAgreementService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(payoutAgreementActions.addPayoutAgreement),
      mergeMap(({ payoutAgreement }) =>
        payoutAgreementService.addPayoutAgreement(payoutAgreement).pipe(
          map(payoutAgreement => {
            toastr.success('Added Successfully!')
            return payoutAgreementActions.addPayoutAgreementSuccess(payoutAgreement)
          }),
          catchError(error => {
            toastr.error('Failed to Add ' + error.message)
            return of(payoutAgreementActions.addPayoutAgreementFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

const saveRevisedPayout$ = createEffect(
  (
    actions$ = inject(Actions),
    payoutAgreementService = inject(PayoutAgreementService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(payoutRevisionActions.saveRevisedPayout),
      mergeMap(({ payout }) =>
        payoutAgreementService.saveRevisedPayout(payout).pipe(
          map(payout => {
            toastr.success('Saved Successfully!')
            return payoutRevisionActions.saveRevisedPayoutSuccess(payout)
          }),
          catchError(error => {
            toastr.error('Failed to Save ' + error.message)
            return of(payoutRevisionActions.saveRevisedPayoutFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

const editPayout$ = createEffect(
  (
    actions$ = inject(Actions),
    payoutAgreementService = inject(PayoutAgreementService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(editPayout),
      mergeMap(({ payout }) =>
        payoutAgreementService.editPayout(payout).pipe(
          map(payout => {
            toastr.success('Edit Successfully!')
            return editPayoutSuccess({ payout })
          }),
          catchError(error => {
            toastr.error('Failed to Edit ' + error.message)
            return of(editPayoutFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const payoutAgreementEffects = {
  loadAllPayoutAgreements$,
  addPayoutAgreement$,
  loadPayoutAgreement$,
  saveRevisedPayout$,
  editPayout$
}
